<template>
    <div class="page">
        <div class="page-content">
            <Header></Header>
            <div class="course">
                <div v-if="status != 'loading'" class="breadcrumbs">
                    <div class="wrapper">
                        <span><router-link class="link" to="/">Главная</router-link></span>
                        <span v-if="lesson.lesson_type == 'lesson'"><router-link class="link" to="/courses">Курсы</router-link></span>
                        <span v-if="lesson.lesson_type == 'webinar'"><router-link class="link" to="/webinars">Вебинары</router-link></span>
                        <span v-if="lesson.lesson_type != 'webinar'" v-html="course[0].title"></span>
                        <span v-html="lesson.title"></span>
                    </div>
                </div>

                <div class="content-wrapper" v-if="status == 'loading'">
                    <strong class="loading">Загрузка...</strong>
                </div>

                <div class="content-wrapper" v-else>
                    <h1 class="main-title" ref="main_title"><span ref="main_title_content" v-html="lesson.title"></span></h1>
                    <router-link v-if="lesson.lesson_type == 'lesson'" to="/courses" class="link _reverse">Курс: <span v-html="course[0].title"></span></router-link>
                    <p v-html="lesson.description"></p>

                    <div class="lesson-content" @click="clickContent" v-html="lesson.content"></div>

                    <div v-if="!$store.getters['auth/userActivated'] && lesson.lesson_type == 'lesson'" class="lesson-done">
                        <div v-if="!lesson.confirmed" class="inline mob-col" halign="between" valign="center">
                            <strong>Вы прошли этот урок?</strong>
                            <div class="button" :status="check_status" @click="lessonPassed()"><div>Да</div></div>
                        </div>
                        <div v-else>
                            <strong>Вы уже прошли этот урок</strong>
                        </div>
                    </div>

                    <div class="next-lesson inline" halign="right">
                        <router-link v-if="lesson.next_id" class="next link " :to="'/lesson/' + lesson.next_id">Смотреть следующий урок</router-link>
                    </div>
                </div>

                <LessonsCarousel page="lesson" v-if="lessons.length && status != 'loading'" :active="$route.params.id" :course="course[0]" :lessons="lessons"></LessonsCarousel>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import LessonsCarousel from '@/components/LessonsCarousel.vue'
    import Footer from '@/components/Footer.vue'

    import * as utils from '@/utils/auth'

    export default {
        metaInfo() {
            return {
                title: this.title,
            };
        },
        components: {
            Header,
            LessonsCarousel,
            Footer
        },
        data () {
            return {
                title: 'Загрузка урока...',
                status: '',
                check_status: '',
                lesson: false,
                course: false,
                lessons: []
            }
        },
        methods: {
            lessonPassed () {
                if (this.$metrika) {
                    let goal = 'confirm_lesson_' + this.lesson.id
                    this.$metrika.reachGoal(goal)
                }
                let pyapi_refresh_token = utils.getCookie()

                this.check_status = 'loading'
                let sendData = {
                    id: this.$route.params.id,
                    pyapi_refresh_token: pyapi_refresh_token
                }
                this.axios({url: 'api/check_lesson', data: sendData, method: 'POST' })
                    .then(resp => {
                        this.lesson.confirmed = 1
                        this.check_status = ''

                        for (let item of this.lessons) {
                            if (item.id == this.$route.params.id) {
                                item.confirmed = 1
                                break
                            }
                        }

                        let data = {
                            user_info: resp.data.user_info,
                            token_info: resp.data.token_info
                        }
                        this.$store.commit('auth/auth_success', data)
                    }).catch(() => {
                        this.check_status = ''
                    })
            },
            getData (id = this.$route.params.id) {
                this.status = 'loading'

                let pyapi_refresh_token = utils.getCookie()

                this.axios({url: 'api/lesson/' + id + '?pyapi_refresh_token=' + pyapi_refresh_token, method: 'GET' })
                    .then(resp => {
                        this.status = ''
                        this.lesson = resp.data.lesson
                        this.lessons = resp.data.lessons
                        this.course = resp.data.course

                        this.title = this.lesson.title

                        let data = {
                            user_info: resp.data.user_info,
                            token_info: resp.data.token_info
                        }
                        this.$store.commit('auth/auth_success', data)

                        this.correctVideosHeight()
                        window.addEventListener("resize", this.correctVideosHeight);

                        this.correctTitleWidth()
                        window.addEventListener("resize", this.correctTitleWidth);

                    }).catch((error) => {
                        if (error.response) {
                            if (error.response.status == 404) {
                                this.$router.push('/not-found')
                            } else if (error.response.status == 403) {
                                let path = ''

                                if (error.response.data.lesson_type == 'webinar') {
                                    path = '/webinars'
                                } else {
                                    path = '/courses'
                                }

                                let query = { not_activated: '1' }

                                if (this.$store.getters['auth/userActivated'] && error.response.data.required_lo) query = { low_lo: error.response.data.required_lo }

                                this.$router.push({
                                    path: path,
                                    query: query
                                })
                            } else {
                                this.$router.push('/courses')
                            }
                        }
                    })
            },
            clickContent (e) {
                const elem = e.target;

                if (elem.href && elem.href.indexOf('#') != -1) { // its link and anchor

                    let linkBasePath = elem.href.split('#')[0]
                    let anchor = elem.href.split('#')[1]
                    let currentPath = location.origin + this.$route.path

                    if (linkBasePath == currentPath) { // same page
                        let scrollToElem = document.getElementsByName(anchor)[0]

                        window.scrollTo({
                            top: scrollToElem.offsetTop - 20,
                            behavior: "smooth"
                        })
                        e.preventDefault()
                    }
                }
            },
            correctVideosHeight() {
                this.$nextTick(() => {
                    let players = document.querySelectorAll(".player")

                    if (players.length) {
                        let width = players[0].getBoundingClientRect().width
                        let height = width / 1.7418

                        for (let player of players) {
                            player.style.height = height + 'px'
                        }
                    }
                })
            },
            correctTitleWidth() {
                this.$nextTick(() => {
                    this.$refs.main_title.style.cssText = null
                    let outerWidth = this.$refs.main_title.getBoundingClientRect().width
                    let innerWidth = this.$refs.main_title_content.getBoundingClientRect().width

                    while (innerWidth > outerWidth) {
                        let fs = parseFloat(window.getComputedStyle(this.$refs.main_title, null).getPropertyValue('font-size'))
                        let new_fs = fs - 1
                        let new_lh = new_fs * 1.125
                        this.$refs.main_title.style.fontSize = new_fs + 'px'
                        this.$refs.main_title.style.lineHeight = new_lh + 'px'

                        outerWidth = this.$refs.main_title.getBoundingClientRect().width
                        innerWidth = this.$refs.main_title_content.getBoundingClientRect().width
                    }
                })
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.correctVideosHeight);
            window.removeEventListener('resize', this.correctTitleWidth);
        },
        beforeRouteUpdate(to, from, next) {
            this.getData(to.params.id)
            next()
        },
        created () {
            this.getData()
        }
    }
</script>